/* eslint-disable react/destructuring-assignment */
import { Fragment, lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ModalContainer } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"
import { EUserRole } from "@/3514/types"

import CoachContainer from "./diagnostic-summary.container.coach"
import ParticipantContainer from "./diagnostic-summary.container.participant"
import type { TDiagnosticSummaryEntityProps as TProps } from "./diagnostic-summary.ui.types"

const LazySummaryModal: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> => import("./diagnostic-summary.modal.container")
)

/**
 * 'Diagnostic Results' entity.
 * Design spec for participant:{@link https://www.figma.com/design/J6qF3Pa6zeK3udtVWLskjd/Participant?node-id=21201-121514&m=dev}
 * Design spec for coach:{@link https://www.figma.com/design/QLhX4KcIViCdMD12xdfvXq/Coach?node-id=5063-59232&m=dev}
 *
 * @return ReactElement
 */
const DiagnosticResultsEntity: FC<TProps> = (props: TProps): ReactElement => (
    <Fragment>
        {props.mode === EUserRole.Participant ? <ParticipantContainer {...props} /> : <CoachContainer {...props} />}

        <ModalContainer modalId={EModalId.DiagnosticSummary} container={LazySummaryModal} />
    </Fragment>
)

DiagnosticResultsEntity.displayName = "DiagnosticResultsEntity"

export { DiagnosticResultsEntity }
